module.exports = __webpack_public_path__ + "static/media/water7.393d3f9b.svg";